export const ACCEPTED_IMAGE_MIME_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
export const ACCEPTED_IMAGE_TYPES_STRING = ACCEPTED_IMAGE_MIME_TYPES.join(',');